// Apolo IDE — useSessionStatusPoll (sprint code-session-board, E2-WS2).
//
// Pull leve do status das sessões enquanto a aba Code está ativa. Refaz na
// montagem e a cada INTERVAL; limpa o timer no unmount/troca de aba (sem leak).
// Status é PULL+poll (não push) — decisão de v1 (board, não notificação).

import { useEffect } from 'react';
import { useAgentStore } from '../store/useAgentStore.js';

const INTERVAL_MS = 8000;

export function useSessionStatusPoll() {
  const active = useAgentStore((s) => s.activeWorkspace === 'code');
  const refresh = useAgentStore((s) => s.refreshSessionStatuses);

  useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;
    const tick = () => { if (!cancelled) refresh(); };
    tick(); // imediato na entrada da aba
    const id = setInterval(tick, INTERVAL_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, [active, refresh]);
}
